import { FormattedMessage } from "react-intl";
import AddQuizIcon from "../../../components/Common/SvgIcons/ManageIcons/AddQuizIcon";
import AddSurveyIcon from "../../../components/Common/SvgIcons/ManageIcons/AddSurveyIcon";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import PublishIcon from "../../../components/Common/SvgIcons/ManageIcons/PublishIcon";
import SubmissionsIcon from "../../../components/Common/SvgIcons/SocialIcons/SubmissionsIcon";
import {
  rejectShotClassActionHandler,
  unLockContributorShotClassActionHandler,
} from "../../../store/actions/actionHandlers/socialActionHandler";
import { colors } from "../../stripeColors";
import { moderateContributions } from "./moderateContributions";
import { social } from "./social";
import PlusIcon from "../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import * as yup from "yup";

export const submisssions = {
  label: "Submissions",
  path: (tenantName) => `${moderateContributions.path(tenantName)}/submissions`,
  viewPath: (tenantName) =>
    `${moderateContributions.path(tenantName)}/viewShotclasses`,
  updatePath: (tenantName) =>
    `${moderateContributions.path(tenantName)}/updateShotclasses`,
  shotClassespath: (params, location, tenantName) => {
    if (location?.pathname?.includes(submisssions.viewPath(tenantName)))
      return `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`;
    else if (location?.pathname?.includes(submisssions.updatePath(tenantName)))
      return `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`;
  },
  icon: (fill) => <SubmissionsIcon fill={fill} />,
  searchPlaceHolder: "Search submissions by name",
  links: (onClick) => [
    {
      key: 1,
      label: "View Comments",
      onClick: () => {
        onClick();
      },
    },
  ],
  buttons: (
    viewCommentModal,
    setViewCommentModal,
    location,
    dispatch,
    params,
    navigate,
    shotClassFormData,
    tenantName,
    saveShotclass,
    saveShotclassLoader
  ) => {
    if (location?.pathname?.includes(submisssions.updatePath(tenantName)))
      return [
        {
          key: 1,
          label: <FormattedMessage id="MYCLASS_UNLOCK" />,
          width: "8",
          onClick: () => {
            dispatch(
              unLockContributorShotClassActionHandler(
                params?.shotclassId,
                navigate,
                location,
                undefined,
                tenantName
              )
            );
          },
        },
        {
          key: 2,
          label: <FormattedMessage id="REJECT_CLASS_TEXT" />,
          width: "8",
          onClick: () =>
            dispatch(
              rejectShotClassActionHandler(
                params?.shotclassId,
                navigate,
                tenantName
              )
            ),
        },
        {
          key: 3,
          label: <FormattedMessage id="SAVE_TXT" />,
          width: "8",
          onClick: () => {
            if (shotClassFormData) {
              saveShotclass();
            }
          },
          loading: saveShotclassLoader,
        },
        {
          key: 4,
          label: "View Comments",
          width: "15",
          onClick: () => {
            setViewCommentModal(!viewCommentModal);
          },
        },
      ];
    else
      return [
        {
          key: 1,
          label: "View Comments",
          width: "15",
          onClick: () => setViewCommentModal(!viewCommentModal),
        },
      ];
  },
  navLinks: (navigate, shortClassesLabel, tenantName) => [
    {
      key: 1,
      label: "Social Connect",
      path: `${social.path(tenantName)}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: moderateContributions.label,
      path: `${moderateContributions.path(tenantName)}`,
      onClick: () =>
        navigate(`${moderateContributions.path(tenantName)}/submissions`),
    },
    {
      key: 3,
      label: shortClassesLabel,
    },
  ],

  tiles: (navigate, location, params, mode, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS_TEXT" />,
      path: `${moderateContributions.path(tenantName)}/${mode}/${
        params?.shotclassId
      }/details`,
      icon: (fill) => <DetailsIcon fill={fill} />,
      color: colors.green,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${moderateContributions.path(tenantName)}/${mode}/${
            params?.shotclassId
          }/details`
        ),
      formData: (formArgs) => [
        {
          key: 1,
          label: "Course Language",
          name: "Language",
          fieldName: "Value",
          fieldValue: "Locale",
          type: "select",
          labelColor: "light",
          valueArr: formArgs.allLanguageVariant,
          defaultValue: formArgs.allLanguageVariant[0]?.Locale,
          required: true,
          disabled: formArgs.shotclassType === "edit",
          loading: formArgs.getLanguagesLoader,
        },
        {
          key: 2,
          label: <FormattedMessage id="USERGROUP_NAME" />,
          name: "ShotClassName",
          placeholder: "Enter Shotclass Name",
          labelColor: "light",
          onChange: formArgs.handleNameExists,
          required: true,
          // disabled: formArgs.shotclassType === "edit",
          loading: formArgs.isShotclassNameExistLoader,
        },
        {
          key: 3,
          label: <FormattedMessage id="TRAINING_TYPE" />,
          name: "TrainingType",
          fieldName: "Name",
          fieldValue: "TypeId",
          buttonLabel: "Select Training Type",
          placeholder: "Search Training Type",
          type: "noSearchTags",
          tagType: "single",
          labelColor: "light",
          // valueArr: formArgs?.trainingTypes,
          searchTagsList: formArgs?.searchTrainingTypeList,
          // onChange: (e) => formArgs?.handleSearchTrainingType(e),
          handleTagList: (tagsList) =>
            formArgs?.setSearchTrainingTypeList(tagsList),
          required: true,
          loading: formArgs?.getTrainingTypesLoader,

          height: "4",
          searchable: true,
          subButtonLabel: "Add New",
          subButtonIcon: PlusIcon,
          handleSubButton: formArgs?.handleAddTrainingType,
          // width: "27",
          disabled: false,
          isTagCheckBoxVisible: false,
          addedTagsVisible: false,
        },
        {
          key: 4,
          label: <FormattedMessage id="TAG_TEXT" />,
          name: "TagsList",
          fieldName: "TagName",
          fieldValue: "TagValue",
          type: "tags",
          placeholder: "Enter Tag Here & Tap Plus Icon",
          labelColor: "light",
          required: true,
          // valueArr: tagsList,
          isValidTagSearch: formArgs?.validTagSearch,
          searchTagsList: formArgs?.searchTagsList,
          onChange: (e) => formArgs?.handleSearchTags(e),
          loading: formArgs?.getShotclassTagLoader,
          // handleTagList: (val) => setTagsList(val),
        },
        {
          key: 5,
          label: <FormattedMessage id="BULKUPLD_DESCRIPTION" />,
          labelMsg: "(Max : 200 Characters)",
          name: "Description",
          type: "textarea",
          placeholder: "Enter Small Description about course",
          labelColor: "light",
          required: true,
        },
        {
          key: 6,
          label: <FormattedMessage id="SUMMARY_TEXT" />,
          labelMsg: "(Max : 500 Characters)",
          name: "Summary",
          type: "textarea",
          placeholder: "Enter Learning Key Points Here",
          labelColor: "light",
          required: true,
        },
        {
          key: 7,
          type: "file",
          label: <FormattedMessage id="CREATE_VIDEOCONTENT_TEXT" />,
          name: "Content.ContentValue",
          disableLabelClick: true,
          labelColor: "light",
          disabled: true,
          // required: true,
          hidden: true,
          fileInputView:
            (formArgs?.shotclassType === "edit" ||
              formArgs?.shotclassType === "copy" ||
              formArgs?.shotclassType === "view") &&
            !formArgs?.contentUpdated,
          handleFileInputView: () => formArgs?.handleViewContentModal(),
          fileInputDownload: formArgs?.isVideoDownload,
          handleFileInputDownload: () => formArgs?.handleDownloadVideo(),
          handleClickFileButton: () => formArgs?.setActiveSection(2),
          handleCancelFileInput: () => formArgs?.handleCancelFileContent(),
        },
        {
          key: 8,
          type: "file",
          label: <FormattedMessage id="CREATE_THUMBNAIL_TEXT" />,
          name: "ThumbnailImage",
          disableLabelClick: true,
          labelColor: "light",
          required: true,
          hidden: true,
          fileInputView:
            formArgs.shotclassType === "edit" ||
            formArgs.shotclassType === "copy" ||
            formArgs.shotclassType === "view",
          handleFileInputView: false,
          handleClickFileButton: () => formArgs.setActiveSection(3),
        },
      ],
    },
    {
      key: 2,
      label: "Add Quiz",
      path: `${moderateContributions.path(tenantName)}/${mode}/${
        params?.shotclassId
      }/addQuiz`,
      icon: (fill) => <AddQuizIcon fill={fill} />,
      color: colors.purple,
      isCompleted: false,
      optionalText: () => "(Optional)",
      onClick: () =>
        navigate(
          `${submisssions.viewPath(location, params, tenantName)}/addQuiz`
        ),
    },
    {
      key: 3,
      label: "Add Survey",
      path: `${moderateContributions.path(tenantName, tenantName)}/${mode}/${
        params?.shotclassId
      }/addSurvey`,
      icon: (fill) => <AddSurveyIcon fill={fill} />,
      color: colors.red,
      isCompleted: false,
      optionalText: () => <p>(Optional)</p>,
      onClick: () =>
        navigate(
          `${moderateContributions.path(tenantName)}/${mode}/${
            params?.shotclassId
          }/addSurvey`
        ),
    },
    {
      key: 4,
      label: "Publish Shotclass",
      path: `${moderateContributions.path(tenantName)}/${mode}/${
        params?.shotclassId
      }/publishShotclass`,
      color: colors.orange,
      isCompleted: false,
      icon: (fill) => <PublishIcon fill={fill} />,
      onClick: () =>
        navigate(
          `${moderateContributions.path(tenantName)}/${mode}/${
            params?.shotclassId
          }/publishShotclass`
        ),
      formData: (formArgs) => [
        {
          key: 1,
          label: <FormattedMessage id="SHOTCLASS_OFFLINE" />,
          name: "OfflineShotclass",
          visible: true,
          disabled:
            (formArgs.formValues?.details?.Content?.ContentMediaType !== 1 &&
              formArgs.formValues?.details?.Content?.ContentMediaType !== 7) ||
            formArgs.formValues?.Other?.IsDistributed,
          toolTipText: "Applicable only for mobile learners",
        },
        {
          key: 2,
          label: <FormattedMessage id="SHOTCLASS_ISVIDEOMANDATORY" />,
          name: "IsVideoMandatory",
          visible:
            formArgs.formValues?.details?.Content?.ContentMediaType === 1,
          disabled: false,
          toolTipText: (
            <>
              Learner can skip the video and
              <br /> continue to quiz or survey
            </>
          ),
        },
        {
          key: 3,
          label: <FormattedMessage id="SHOTCLASS_ISRANDOMQSALLOWED" />,
          name: "QuestionJumbling",
          visible:
            formArgs.formValues?.addQuiz?.TotalQuestionCount > 1 || false,
          disabled: false,
          toolTipText: "Learn will get question in jumbling",
        },
        {
          key: 4,
          label: <FormattedMessage id="SHOTCLASS_SHOWCORANS" />,
          name: "ShowCorrectAnswers",
          visible:
            formArgs.formValues?.addQuiz?.TotalQuestionCount > 0 || false,
          disabled: false,
          toolTipText: (
            <>
              Once submit quiz answers can be
              <br /> shown
            </>
          ),
        },
        {
          key: 5,
          label: <FormattedMessage id="LEARNERCHANGE_SHOWCORANS" />,
          name: "CanChangeAnswers",
          visible: formArgs.formValues?.addQuiz?.TotalQuestionCount > 0,
          disabled: false,
          toolTipText: "Can change answers before submit",
        },
        {
          key: 6,
          label: <FormattedMessage id="SHOTCLASS_ISSURVEYMADATORYFORUSER" />,
          name: "IsSurveyMandatory",
          visible: formArgs.formValues?.addSurvey?.TotalQuestionCount > 0,
          disabled: false,
          toolTipText: (
            <>
              If not selected learner can skip
              <br /> survey
            </>
          ),
        },
        {
          key: 7,
          label: <FormattedMessage id="IS_RESTRICTEDCLASS_TEXT" />,
          name: "HasRestricted",
          visible: true,
          disabled: false,
          toolTipText: (
            <>
              Restrict the class to applicable
              <br /> groups
            </>
          ),
        },
        {
          key: 8,
          name: "ShotclassTargetGroupMapping",
          type: "noSearchTags",
          fieldName: "Name",
          fieldValue: "UserGroupId",
          placeholder: "Search User Group",
          height: "5",
          width: "27",
          visible: formArgs?.hasRestricted,
          loading: formArgs?.getUserGroupsLoader,
          disabled: false,
          searchable: true,
          searchTagsList: formArgs?.userGroups,
          handleTagList: (tagsList) => formArgs?.setUserGroups(tagsList),
        },
      ],
    },
  ],
};

export const moderateContributionDetailsSchema = yup.object().shape({
  Language: yup.string(),
  TrainingType: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .min(1, "Training Type is required!"),
  ShotClassName: yup
    .string()
    .trim()
    .required("Name is required!")
    .max(80, "Only 80 characters allowed!"),
  isContentRequired: yup.boolean().notRequired(),
  Content: yup.object().when("isContentRequired", {
    is: true,
    then: yup.object().shape({
      ContentValue: yup.mixed(),
      ContentMediaType: yup.number(),
      ContentMediaExtension: yup.string(),
    }),
    otherwise: yup.object().shape({
      ContentValue: yup.mixed(),
      ContentMediaType: yup.number(),
      ContentMediaExtension: yup.string(),
    }),
  }),
  ThumbnailImage: yup
    .mixed()
    .test("ThumbnailImage", "Thumbnail Image is required!", (value) => {
      if (value !== null && Object.keys(value)?.length > 0) return true;
      return false;
    }),
  TagsList: yup
    .array(
      yup.object().shape({
        TagName: yup.string(),
        TagValue: yup.string(),
      })
    )
    .min(1, "Tag is required!"),
  TagSearch: yup.string().notRequired(),
  Description: yup
    .string()
    .trim()
    .required("Description is required!")
    .max(200, "Only 200 characters allowed"),
  Summary: yup
    .string()
    .trim()
    .required("Summary is required!")
    .max(500, "Only 500 characters allowed"),
});
